// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__AxAZB","modalContent":"Modal_modalContent__WxXZN","btn":"Modal_btn__wxt2H"};